import React, { SVGProps } from "react";

export default function RerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <rect width="38" height="38" x="1" y="1" fill="#FFF" rx="2" />
        <path
          fill="#EC1D24"
          d="M36.06 3h-.31c-.075.094-.142.195-.2.3l-2.93 5.91c.792.503 1.676.843 2.6 1 .59.08 1.19.08 1.78 0V3.94c0-.52-.42-.94-.94-.94z"
        />
        <path
          fill="#C02026"
          d="M13.16 34.43v-.15l.2-.34 3.82-6.28c.416-1.034 1.388-1.737 2.5-1.81.14-.01.28-.01.42 0l1.84.31.72-1.46 1.75-3.53 9-18.2H3.94c-.255 0-.498.103-.676.286-.177.183-.272.43-.264.684v32.12c0 .52.42.94.94.94h8.75l.36-2.12c.021-.153.058-.304.11-.45z"
        />
        <path
          fill="#EC1D24"
          d="M31.86 30c-2.903-.528-5.521-2.078-7.38-4.37l-2.28 4.6v.6c2.12 2.786 5.205 4.677 8.65 5.3 2.06.327 4.17.155 6.15-.5v-6c-1.664.508-3.42.634-5.14.37zM34.1 16.89c-1.596-.287-3.055-1.084-4.16-2.27l-2.88 5.8c1.668 1.504 3.727 2.506 5.94 2.89 1.326.218 2.68.198 4-.06v-6.48c-.949.235-1.935.276-2.9.12z"
        />
        <path fill="#991B1E" d="M3 9.65L9.2 15.84 10.9 14.14 3 6.24z" />
        <path
          fill="#991B1E"
          fillRule="nonzero"
          d="M31.79 6.41L18.3 6.41 18.3 8.82 30.59 8.82z"
        />
        <path
          fill="#EC1D24"
          d="M26.47 17.11L27.98 14.07 21.58 7.67 26.21 3 21.68 3 3 21.84 3 26.41 19.32 9.95z"
        />
        <path
          fill="#ED3043"
          d="M37 36.06v-5.33l-17.2-2.88c-.39-.06-.58.3-.86.81L15.1 35c-.09.51-.42 1.17.31 1.48l3.2.54h17.45c.253 0 .495-.102.672-.282.177-.181.273-.425.268-.678z"
        />
        <path
          fill="#E1E2E3"
          d="M37 10.27c-.59.08-1.19.08-1.78 0-.924-.157-1.808-.497-2.6-1l-2.68 5.41c1.105 1.186 2.564 1.983 4.16 2.27.965.156 1.951.115 2.9-.12v-6.56z"
        />
        <path
          fill="#ED3043"
          d="M29.46 22.09L31.68 16c-.64-.375-1.225-.836-1.74-1.37l-2.88 5.8c.737.639 1.542 1.196 2.4 1.66zM24.48 25.62l-2.28 4.6v.6c.863 1.102 1.873 2.08 3 2.91l2-5.61c-1.018-.704-1.933-1.545-2.72-2.5z"
        />
        <path
          fill="#FAF7FA"
          d="M32.62 9.21L31.26 12l-1.32 2.66c.517.523 1.102.974 1.74 1.34l2.23-6.13c-.45-.18-.881-.4-1.29-.66z"
        />
        <path
          fill="#E1E2E3"
          d="M37 23.25c-1.32.258-2.674.278-4 .06-2.206-.388-4.258-1.39-5.92-2.89l-2.58 5.2c1.852 2.291 4.463 3.845 7.36 4.38 1.716.277 3.473.164 5.14-.33v-6.42z"
        />
        <path
          fill="#FAF7FA"
          d="M27.06 20.42l-2.58 5.2c.809.96 1.748 1.801 2.79 2.5l2.19-6c-.86-.477-1.665-1.047-2.4-1.7z"
        />
        <path
          fill="#C02026"
          d="M29.12 37l-13.55-2.27c-.138-.011-.275.033-.38.124-.105.09-.17.218-.18.356l-.3 1.79h14.41z"
        />
        <path
          fill="#C02026"
          d="M29 37h7.08c.52 0 .94-.42.94-.94v-.43c-1.981.652-4.09.82-6.15.49-2.062-.354-4.012-1.19-5.69-2.44l2.55 3.08L29 37z"
        />
        <rect width="34" height="34" x="3" y="3" rx="1" />
        <path
          fill="#FEFEFE"
          fillRule="nonzero"
          d="M7.13 6.81h2.28c.71-.06 1.42.135 2 .55.496.444.752 1.097.69 1.76.02.455-.091.906-.32 1.3-.196.31-.477.556-.81.71l1.5 2.68H10.6l-1.19-2.4h-.63v2.4H7.13v-7zM9.44 10c.256.018.51-.053.72-.2.175-.177.263-.422.24-.67.03-.261-.067-.521-.26-.7-.24-.148-.52-.214-.8-.19h-.56V10h.66zM13.07 6.81L17.36 6.81 17.36 8.23 14.73 8.23 14.73 9.53 17.13 9.53 17.13 11 14.73 11 14.73 12.44 17.36 12.44 17.36 13.86 13.07 13.86zM18.54 6.81h2.28c.71-.06 1.42.135 2 .55.496.444.752 1.097.69 1.76.02.455-.091.906-.32 1.3-.196.31-.477.556-.81.71l1.5 2.68H22l-1.19-2.4h-.63v2.4h-1.64v-7zM20.85 10c.256.018.51-.053.72-.2.175-.177.263-.422.24-.67.03-.261-.067-.521-.26-.7-.24-.148-.52-.214-.8-.19h-.56V10h.66z"
        />
        <path
          fill="#991B1E"
          d="M24.45 21.2L24.97 20.14 3 20.14 3 22.55 23.77 22.55z"
        />
        <path
          fill="#ED3043"
          d="M36.06 3h-.31c-.075.094-.142.195-.2.3l-2.93 5.91c.409.25.837.468 1.28.65l2.46-6.8c-.097-.034-.198-.054-.3-.06z"
        />
        <path
          fill="#E5E5E5"
          fillRule="nonzero"
          d="M37 1c1.105 0 2 .895 2 2v34c0 1.105-.895 2-2 2H3c-1.105 0-2-.895-2-2V3c0-1.105.895-2 2-2h34m0-1H3C1.343 0 0 1.343 0 3v34c0 1.657 1.343 3 3 3h34c1.657 0 3-1.343 3-3V3c0-1.657-1.343-3-3-3z"
        />
      </g>
    </svg>
  );
}
